import {Component, inject, signal} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ModalRef} from '@shared/components/modal/modal.ref';
import {MODAL_CONFIG} from '@shared/components/modal/modal.token';
import {ModalConfig} from '@shared/components/modal/modal.config';
import {CompanyService} from '@services/company.service';
import {NotificationService} from '@services/frontend/notification.service';

@Component({
  selector: 'app-expert-bulk-import-dialog',
  templateUrl: './expert-bulk-import-dialog.html',
})
export class ExpertBulkImportDialog {
  private readonly modalRef = inject(ModalRef<boolean>);
  private readonly config = inject<ModalConfig | null>(MODAL_CONFIG, {optional: true});
  private readonly companyService = inject(CompanyService);
  private readonly notificationService = inject(NotificationService);

  readonly templatePreviewUrl = '/images/modele-import.png';
  downloadingTemplate = signal(false);
  uploading = signal(false);

  atCompanyLimit(): boolean {
    return Boolean(this.config?.data?.atCompanyLimit);
  }

  downloadTemplate(): void {
    this.downloadingTemplate.set(true);
    this.companyService.downloadImportTemplate().subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'modele_import.xlsx';
        anchor.click();
        URL.revokeObjectURL(url);
        this.downloadingTemplate.set(false);
      },
      error: () => {
        this.notificationService.error('Impossible de télécharger le modèle pour le moment.', 3500);
        this.downloadingTemplate.set(false);
      },
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    if (this.atCompanyLimit()) {
      this.notificationService.error(
        'Limite de clients atteinte. Supprimez un client avant d\'importer.',
        4000
      );
      input.value = '';
      return;
    }

    this.uploading.set(true);
    this.companyService.uploadExcel(file).subscribe({
      next: () => {
        this.notificationService.success(
          'Fichier Excel importé avec succès. Les entreprises seront ajoutées sous peu.',
          4000
        );
        input.value = '';
        this.uploading.set(false);
        this.modalRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        const message = typeof err.error === 'string' && err.error
          ? err.error
          : 'Erreur lors de l\'import du fichier Excel';
        this.notificationService.error(message, 4000);
        input.value = '';
        this.uploading.set(false);
      },
    });
  }

  close(): void {
    this.modalRef.close(false);
  }
}
